// noinspection JSUnresolvedReference

import { signIn } from 'supertokens-auth-react/recipe/emailpassword';
import { FormErrors, isNotEmpty } from '@mantine/form';
import { TransformSuperTokensFormErrors } from '../../../Utils/TransformSuperTokensFormErrors.ts';
import isEmail from 'validator/es/lib/isEmail';
import assert from 'assert';
// import isLength from 'validator/es/lib/isLength';

export interface SingInParams {
    email: string;
    password: string;
}

export type SingInReturn = Promise<
    | { status: 'ok' }
    | { status: 'error'; message: 'FORM_ERRORS'; formErrors: FormErrors }
    | { status: 'error'; message: 'WRONG_CREDENTIALS' }
>;

/**
 * @param email
 * @param password
 * @throws AssertionError
 * @constructor
 */
export async function SignIn({ email, password }: SingInParams): SingInReturn {
    assert(isNotEmpty(email));
    assert(isEmail(email));
    assert(isNotEmpty(password));
    // assert(isLength(password, { min: 8 }));

    const response = await signIn({
        formFields: [
            {
                id: 'email',
                value: email.trim(),
            },
            {
                id: 'password',
                value: password.trim(),
            },
        ],
    });

    switch (response.status) {
        case 'OK': {
            return { status: 'ok' };
        }
        case 'FIELD_ERROR': {
            return {
                status: 'error',
                message: 'FORM_ERRORS',
                formErrors: TransformSuperTokensFormErrors(response.formFields),
            };
        }
        case 'WRONG_CREDENTIALS_ERROR': {
            return { status: 'error', message: 'WRONG_CREDENTIALS' };
        }
        default: {
            throw new Error('Unkown response', { cause: response });
        }
    }
}
